// getPlayerRealSize.js
'use strict';
/**
 * Get player real size
 * @param {object} param
 * @param {import('video.js').VideoJsPlayer} param.player - video js player.
 * @return video player real size (realWidth, realHeight).
 */
const getPlayerRealSize = ({ player }) => {
  if (!player) {
    return {
      realWidth: 0,
      realHeight: 0,
    };
  }
  const videoWidth = player.videoWidth?.() || 0;
  const videoHeight = player.videoHeight?.() || 0;
  const currentWidth = player.currentWidth?.() || 0;
  const currentHeight = player.currentHeight?.() || 0;

  const wRatio = videoWidth / currentWidth;
  const hRatio = videoHeight / currentHeight;
  const ratio = wRatio > hRatio ? wRatio : hRatio;

  const realWidth = Math.floor(videoWidth / ratio);
  const realHeight = Math.floor(videoHeight / ratio);

  return {
    realWidth,
    realHeight,
  };
};

export default getPlayerRealSize;
